import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=a1b352ac&scoped=true&lang=scss"

import exportComponent from "/Users/zhangjun/Desktop/project/envo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1b352ac"]])

export default __exports__